/**
 * Personal Injury & Accident Claims hub — global subcategory registry.
 */
import {
  PERSONAL_INJURY_CLAIMS_SLUG,
  personalInjuryClaimsDefaultData,
} from "./personalInjuryClaimsData";
import {
  PersonalInjuryClaimsArticlesTab,
  PersonalInjuryClaimsMediaTab,
  PersonalInjuryClaimsOverviewTab,
} from "./PersonalInjuryClaimsDesign";

export const personalInjuryClaimsModule = {
  slug: PERSONAL_INJURY_CLAIMS_SLUG,
  getDefaultData: () => personalInjuryClaimsDefaultData,
  Views: {
    overview: PersonalInjuryClaimsOverviewTab,
    articles: PersonalInjuryClaimsArticlesTab,
    media: PersonalInjuryClaimsMediaTab,
  },
};
